import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { Matches, RouterContextProvider } from '@tanstack/react-router';
import { AppShell } from '@widgets/app-shell';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@shared/ui/page-sheet';

import { router } from './lib/routes';
import { Providers } from './lib/providers';

dayjs.locale('ru');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Moscow');

const App = () => (
  <HelmetProvider>
    <Providers>
      <RouterContextProvider router={router}>
        <AppShell>
          <Matches />
        </AppShell>
      </RouterContextProvider>
    </Providers>
  </HelmetProvider>
);

export default App;
